import './App.css';
import Home from './Home';
import * as React from 'react';


function App() {
  return (
    <>
    <Home />
    </>
  );
}

export default App;
